import React from 'react'
import { checkTranslation, imageAddress, priceStandardView, translate } from '../../utils/useful'
import Collapsible from 'react-collapsible';
import SelectInput from './SelectInput';
import Responsive from '../Responsive';
import HttpServices from '../../utils/Http.services';
// import SelectInput from '../../components/inputs/SelectInput';

class FullfilmentSelectInput extends React.Component {
    state = {
        collapses: {},
        itemsFulfilmentsRelation: {},
        itemsObject: {}
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {

        if (this.props.items != prevProps.items) {
            this.init()
        }
    }

    init = () => {

        let items = this.props.items
        let itemsObject = {}

        if (Array.isArray(items)) {
            items.forEach(element => {
                itemsObject[element?._id] = element
            });
        }

        this.setState({ itemsObject })
        // this.getValidFulfillments()
    }


    getValidFulfillments = () => {

        // console.log("getValidFulfillments")

        // let cart = this.props.carts?.applets[this.props.variables?.appletId]
        let items = this.props.items
        let itemsIds = []

        if (Array.isArray(items)) {

            items.forEach(element => {
                let id = element.product
                if (typeof id == 'object' && id._id) {
                    id = id._id
                }
                if (id) {
                    itemsIds.push(id)
                }
            });
        }

        // console.log(items)
        // console.log(itemsIds)

        // return

        let body = {
            items: itemsIds,
        }

        HttpServices.request('getValidFulfillmentsOfProducts', body, (fetchResult, fetchError, fetchStatus) => {

            if (fetchError) {
                console.log(fetchError)
                // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: checkTranslation(fetchError.message) })
                return
            }

            // console.log(fetchResult)

            // return
            let fulfillmentInfo = null//fetchResult.validFulfillments


            this.createFulfullmentGroups(fulfillmentInfo, fetchResult.validFulfillments, fetchResult.itemsFulfillments, items, fulfillmentInfo?.leftOverItems)

            // console.log(cart.fulfillmentInfo)

            this.setState({ activeFulfillment: fulfillmentInfo })

        })

    }



    createFulfullmentGroups(activeFulfillment, fulfillmentsList, itemsFulfillments, items, leftOverItems) {

        let fulfilmentGroups = []
        let itemsFulfilmentsRelation = {}
        let leftOverGroup


        // console.log("activeFulfillment", activeFulfillment)
        // console.log("fulfillmentsList", fulfillmentsList)
        // console.log("itemsFulfillments", itemsFulfillments)



        items.forEach(item => {

            if (itemsFulfillments && Array.isArray(itemsFulfillments[item._id])) {

                itemsFulfillments[item._id].forEach(itemsFulfillment => {

                    fulfillmentsList.forEach(fulfillment => {
                        if (fulfillment._id == itemsFulfillment) {
                            if (!itemsFulfilmentsRelation[item._id]) {
                                itemsFulfilmentsRelation[item._id] = []
                            }
                            let selectValue = { _id: fulfillment._id, value: fulfillment._id, title: fulfillment.name }
                            itemsFulfilmentsRelation[item._id].push(selectValue)
                        }
                    });

                });



            }
        });


        leftOverGroup = {
            items: [],
            fulfillment: {
                name: translate('Following items are not in an valid fulfillment group. You need to move them to a filfillment group.'),
                description: translate('If there is no fulfillment available for any of the items, You can not proceed. You may need to contact the hub support for further assitant.'),
            }
        }


        if (Array.isArray(leftOverItems) && leftOverItems.length > 0) {


            leftOverItems.forEach(item => {
                items.forEach(rawItem => {
                    if (item == rawItem._id) {

                        leftOverGroup.items.push(rawItem)
                    }

                });

            });


        }

        // console.log("activeFulfillment?.groups",activeFulfillment?.groups)

        if (Array.isArray(activeFulfillment?.groups) && Array.isArray(fulfillmentsList)) {


            activeFulfillment?.groups.forEach((group, index) => {

                let groupId = typeof group.fulfillment == 'object' ? group.fulfillment?._id : group.fulfillment
                let newGroup = { items: [], amounts: group.amounts }


                fulfillmentsList.forEach(rawFulfillment => {

                    if (rawFulfillment._id == groupId) {
                        newGroup.fulfillment = rawFulfillment
                    }
                })

                if (Array.isArray(group.items)) {


                    group.items.forEach(item => {

                        items.forEach(rawItem => {
                            if (rawItem._id == item) {

                                newGroup.items.push(rawItem)

                            }
                        })

                    })
                }

                if (!newGroup.fulfillment && newGroup.items.length > 0) {

                    newGroup.items.forEach(rawItem => {

                        leftOverGroup.items.push(rawItem)


                    });
                }

                if (newGroup.fulfillment && newGroup.items.length > 0) {

                    let posibilities = {}

                    fulfillmentsList.forEach(rawFulfillment => {


                        if (rawFulfillment._id != groupId) {


                            let newPosibility = { items: [], id: rawFulfillment._id, fulfillment: rawFulfillment }

                            group.items.forEach(item => {


                                if (itemsFulfillments[item] && itemsFulfillments[item].includes(rawFulfillment._id)) {
                                    newPosibility.items.push(item)

                                }
                            })

                            if (newPosibility.items.length > 0) {
                                posibilities[newPosibility.id] = newPosibility
                            }
                        }

                    });


                    if (Object.values(posibilities).length > 0) {
                        newGroup.posibilities = Object.values(posibilities)
                    }


                    fulfilmentGroups.push(newGroup)
                }
            })



            // TO DO: LEFT OVER ITEMS
        }

        // console.log(leftOverGroup)

        if (leftOverGroup.items.length == 0) {
            leftOverGroup = null
        }

        // console.log(itemsFulfilmentsRelation)
        // return
        this.setState({ fulfilmentGroups, leftOverGroup, itemsFulfilmentsRelation })

    }


    renderGroup(group, gIndex, isLeftOverGroup) {
        // console.log("group",group)
        let fulfilmentGroups = this.props.fulfillmentInfo?.groups

        return (
            <div className='mb-2 br-10' style={{ backgroundColor: "#fff" }}>

                <div className='pb-1' style={{ borderBottom: '1px solid #eee' }}>

                    {Array.isArray(group.posibilities) && group.posibilities.map((posibility, index) => {
                        return (
                            <div className='pb-3 w-100 mb-2 pt-1' style={{ borderBottom: "1px solid #f6f6f6" }} >

                                {/* {posibility.sameItems ? ( */}
                                <button className='flexc w-100' onClick={() => this.changeItemsFulfillment(posibility.items, posibility.fulfillment?._id)}>
                                    <label className="checkbox-container " >
                                        <input type="checkbox" checked={!this.state.checkBox} />
                                        <span className="radioMark"></span>
                                    </label>
                                    {posibility.sameItems ? (
                                        <div className='flexc'>
                                            <p className='font-size-18 title-color pld-2 text-bold'>{checkTranslation(posibility?.fulfillment?.name)} </p>
                                            <span className='text-smaller text-semibold br-20 px-2 py-1 mld-2' style={{ background: '#eee', color: '#444' }} >Can be used for all items of group </span>
                                        </div>
                                    ) : (
                                        <div className='flexc'>
                                            <p className='font-size-14 title-color pld-2 text-bold'>{checkTranslation(posibility?.fulfillment?.name)} </p>
                                            <span className='text-smaller text-semibold br-20 px-2 py-1 mld-2' style={{ background: '#eee', color: '#444' }} >Can be used for {posibility.items.length} items of this group</span>
                                        </div>
                                    )}

                                </button>
                                {/* ) : (
                            <div className='flexc'>
                                <div className='flexcc'>
                                    <ActionsBtn index={index} actions={this.state.actions} actionClicked={this.actionClicked} currentRecord={this.props.currentRecord} colors={this.props.colors} />
                                </div>
                                <div className='flexc'>
                                    <p className='font-size-14 title-color pld-2 text-bold'>{checkTranslation(posibility?.fulfillment?.name)} </p>
                                    <span className='text-smaller text-semibold br-20 px-2 py-1 mld-2' style={{ background: '#eee', color: '#444' }} >Can be used for {posibility.items.length} items of this group</span>
                                </div>
                            </div>
                        )} */}

                                {posibility?.fulfillment?.description && (
                                    <div className='mt-1'>
                                        <p className='font-size-12 des-color  pld-2 mt-1'>{checkTranslation(posibility?.fulfillment?.description)}</p>
                                    </div>
                                )}
                            </div>
                        )
                    })}

                    <div className='d-flex justify-content-between'>


                        <div className='pt-1'>

                            {Array.isArray(group.posibilities) && group.posibilities.length > 0 ? (
                                <button className='flexc pb-2 w-100' >
                                    <label className="checkbox-container " >
                                        <input type="checkbox" checked={true} />
                                        <span className="radioMark"></span>
                                    </label>

                                    <p className='font-size-16 title-color  text-bold'>{checkTranslation(group?.fulfillment?.name)}</p>

                                </button>
                            ) : (
                                <p className='font-size-16 title-color  text-bold'>{checkTranslation(group?.fulfillment?.name)}</p>
                            )}

                            {!isLeftOverGroup && (

                                <p className='font-size-12 des-color text-semibold  mt-1'> <span className='font-size-12 '>{`Shipment ${gIndex + 1} of ${fulfilmentGroups?.length}`}</span> - {group.items?.length}{translate(' items')}</p>
                            )}
                        </div>

                        {!isLeftOverGroup && (

                            <div>
                                {(group.amounts?.final > 0 || (group.amounts?.base != group.amounts?.final)) ? (
                                    <div>
                                        <p className='font-size-16 weight-700  '>Cost {group.amounts?.base != group.amounts?.final && (<span className='text-smaller' style={{ color: "#777", textDecoration: 'line-through' }}>${priceStandardView(group.amounts?.base)}</span>)} ${priceStandardView(group.amounts?.final)}</p>
                                    </div>
                                ) : (
                                    <div>
                                        <p className='font-size-16 weight-700  '>{translate("Free")}</p>
                                    </div>
                                )}

                            </div>
                        )}
                    </div>

                    <p className='font-size-13 des-color  pld-2 mt-2'>{group.fulfillment.description}</p>
                </div>

                <button className='mt-2' onClick={() => this.changeCollapse(gIndex)}>
                    {this.state.collapses[gIndex] ? (
                        <p className='text-link'>{translate("Show items list")}</p>
                    ) : (
                        <p className='text-link'>{translate("Hide items list")}</p>
                    )}
                </button>
                <Collapsible open={!this.state.collapses[gIndex]} transitionTime={50}>
                    <div className='mt-2 d-flex sc-gray2' style={{ overflow: 'auto' }}>
                        {Array.isArray(group.items) && group.items?.map((props, iIndex) => {
                            // console.log(props)
                            let id = props
                            if (typeof id == 'object') {
                                id = id?._id
                            }
                            let item = this.state.itemsObject[id]
                            return (
                                <div>{this.renderItem(group, item, iIndex, isLeftOverGroup)}</div>
                            )
                        })}
                    </div>
                </Collapsible>


            </div>
        )
    }




    renderItem(group, props, iIndex, isLeftOverGroup) {

        let selectItems = null//this.state.itemsFulfilmentsRelation[props._id]
        let product = props?.product
        if (typeof product != 'object') {
            product = this.props.fullProducts[props?.product]
        }

        return (
            // <div key={props?._id} className={'d-flex pt-0 pb-3 ' + (this.props.width < 576 ? ' flex-wrap' : '')}>
            <div key={props?._id} className={'pt-0 pb-3 prd-4 flex-1'} style={{ width: 150 }}>

                {/* <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "100%", sm: '80px' }}> */}

                <div className=' d-flex'>
                    <img width={'100%'} className='br-5' style={{ aspectRatio: '1 / 1', objectFit: 'cover', width: 80, height: 80 }} src={imageAddress(product?.media)} onClick={() => this.changePage('product', ['product', product?._id])} alt='' />
                </div>

                {/* </Responsive> */}

                {/* <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "100%" }}> */}

                {/* <div className={' w-100 ' + (this.props.width < 576 ? '' : 'mld-4')}> */}
                <div className={' mt-2'}>

                    <div className='mb-1' >
                        <p className='font-size-14 weight-500 '>{checkTranslation(product?.name)}</p>
                    </div>


                    {props?.variants && (
                        <div className='w-100'>
                            {Object.entries(props?.variants)?.map(([key, value]) => {
                                return (
                                    <p className='font-size-12 weight-400 main-c7 mld-1 ' style={{ textTransform: 'capitalize', marginTop: 2 }}><span className='font-size-12 weight-400'>{key}:</span> {value}</p>
                                )
                            })}
                        </div>
                    )}

                    {typeof props?.additionals == 'object' && (
                        <div className='w-100'>
                            {Object.entries(props?.additionals)?.map(([key, value]) => {
                                return (
                                    <div>
                                        <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}>{key}:
                                            {typeof value == 'object' && Object.entries(value)?.map(([optionKey, optionValue], oindex) => {
                                                return (
                                                    <span>
                                                        {optionKey == 'text' ? (
                                                            <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}> {optionValue?.value}</span>

                                                        ) : (
                                                            <>
                                                                <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'caspanitalize' }}>{optionKey}
                                                                    {optionValue?.priceDifference && (
                                                                        <span className='font-size-12 weight-400 main-c7 mld-1'>
                                                                            ({(optionValue?.value != true && optionValue?.value > 1) ? (optionValue?.value + "*" + optionValue?.priceDifference) : ("$" + optionValue?.priceDifference)})
                                                                        </span>
                                                                    )}
                                                                </span>

                                                            </>
                                                        )}
                                                        {(oindex < (Object.entries(value).length - 1)) && (
                                                            <span className='mld-1'>,</span>
                                                        )}
                                                    </span>
                                                )
                                            })}
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                    <div className='flexcb w-100 mt-2 prd-3' >

                        <div className='px-2 py-1 br-20' style={{ background: '#eee' }}>
                            <p className='text-smaller text-semibold flexc main-c7' style={{ whiteSpace: 'nowrap' }}>{translate("Quantity")} <span className='mld-1'>{props?.count}</span></p>
                        </div>

                    </div>

                    {selectItems && ((isLeftOverGroup && selectItems?.length > 0) || (!isLeftOverGroup && selectItems?.length > 1)) && (
                        <>
                            <div className='bordered-input mt-3 w-80 flex-1' style={{ maxWidth: 300 }}>
                                <p className='mt-1 text-smaller text-semibold px-1 ' style={{ color: '#777' }}>{translate("Current fulfillment")}</p>
                                <div className='cursor-pointer'>
                                    <SelectInput data={group?.fulfillment?._id} changeValue={(key, value) => this.changeItemsFulfillment([props?._id], value)} header={{ key: 'type', information: { items: selectItems, placeholder: '{{lang}}Select ...', required: true }, required: true }} />
                                </div>
                            </div>
                        </>
                    )}


                </div>

                {/* </Responsive> */}
            </div>
        )

    }


    changeItemsFulfillment = () => {

    }


    changeCollapse = (index) => {
        let collapses = this.state.collapses ?? {}
        collapses[index] = !collapses[index]
        this.setState({ collapses })
    }



    render() {

        let fulfilmentGroups = this.props.fulfillmentInfo?.groups

        return (
            <div className='pt-2 px-1' style={{ borderTop: '1px solid #eee' }}>

                {Array.isArray(fulfilmentGroups) && fulfilmentGroups.map((group, gIndex) => {
                    return (this.renderGroup(group, gIndex))
                })}


                {this.state.leftOverGroup && (

                    this.renderGroup(this.state.leftOverGroup, null, true)
                )}

            </div>
        )
    }
}

export default FullfilmentSelectInput;